module.exports = __webpack_public_path__ + "img/309.cef659ac.jpg";